import React, { useMemo, useState } from "react";
import { Input, InputProps } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface StyledInputProps extends InputProps {
  icon?: React.ReactNode;
}

const StyledInput: React.FC<StyledInputProps> = ({
  className,
  icon,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const isControlled = value !== undefined;
  const [uncontrolledValue, setUncontrolledValue] = useState<string>(
    defaultValue?.toString() ?? ""
  );

  const currentValue = isControlled ? value : uncontrolledValue;
  const hasValue = useMemo(() => {
    if (currentValue === undefined || currentValue === null) {return false;}
    if (Array.isArray(currentValue)) {return currentValue.length > 0;}
    return String(currentValue).length > 0;
  }, [currentValue]);

  return (
    <Input
      {...props}
      value={isControlled ? value : uncontrolledValue}
      onChange={event => {
        if (!isControlled) {
          setUncontrolledValue(event.target.value);
        }
        onChange?.(event);
      }}
      prefix={icon ?? <SearchOutlined />}
      className={`styled-input ${hasValue ? "styled-input--has-value" : ""} ${
        className || ""
      }`}
    />
  );
};

export default StyledInput;
